export const generateRandomHash = () => [...Array(20)].map(() => Math.random().toString(20)[2]).join('');
